// Define interfaces for the data structure
interface CredentialType {
	slug: string
	displayName: string
	displayOrder: number
}

interface CredentialTypesState {
	credTypes: CredentialType[]
}

function convertJsonToCredentialType(json: any): CredentialType {
	return {
		slug: json.slug,
		displayName: json.display_name,
		displayOrder: json.order,
	}
}

// Define the Pinia store
export const useCredentialTypeStore = defineStore("credentialTypeStore", {
	state: (): CredentialTypesState => ({
		credTypes: [],
	}),

	getters: {
		getAll: (state: CredentialTypesState) => () => {
			return [...state.credTypes].sort((a, b) => a.displayOrder - b.displayOrder)
		},
	},

	actions: {
		storeCredentialTypesFromJson(credTypes: any) {
			credTypes.forEach((credType: any) => {
				this.credTypes.push(convertJsonToCredentialType(credType))
			})
		},
		clear() {
			this.credTypes = []
		},
	},

	persist: {
		key: "up_credentialTypeStore", // Make sure this key is unique
		storage: localStorage, // or cookies if you're using cookie storage
	},
})
